/** Case-insensitive target match for active-job discovery. */
export function normalizeTargetKey(name: string): string {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

export function targetsMatch(a: string, b: string): boolean {
  const ka = normalizeTargetKey(a);
  const kb = normalizeTargetKey(b);
  return Boolean(ka && kb && ka === kb);
}
